<template>
  <div>
    <CgImp
    class="contentWrapper"
    :campaignType="campaignType"
    :checkDate="checkDate"
    :clickDate="clickDate"
    :viewData="viewData.data"
    ></CgImp>
    <dateTable
    :checkDate="checkDate"
    :clickDate="clickDate"
    :campaginDaysData="viewData.daysData"
    :dataInfo="viewData.data"
    tab="creativeGroup"
    ></dateTable>
  </div>
</template>

<script>
  import {mapState, mapMutations} from 'vuex'
  import {isInterPlay, checkCampaignType} from '@/assets/func'

  import CgImp from '@/components/campaign/creativeGroup/CgImp'
  import dateTable from '@/components/campaign/campaignBotTable/dateTable'
  import InterPlayCrBottom from '@/components/campaign/campaignBotTable/InterPlayCrBottom'

  export default {
    name: 'creativeGroupMain',
    components: {
      CgImp,
      dateTable,
      InterPlayCrBottom
    },
    data () {
      return {
        campaign: {},
        selectedDate: [],
        isExcel: false
      }
    },
    methods: {
      ...mapMutations([
        'setCampaignDetailTap'
      ]),
      checkDate (date) { // 캠페인 상세 -> 상품,사이즈,소재/ 일별 에서 선택여부 확인(상세 데이터 표시/숨김에 사용)
        return this.selectedDate.indexOf(date) > -1
      },
      clickDate (date) { // 선택한 날짜가 이미 있으면 제거, 없으면 리스트에 추가
        if (this.checkDate(date)) {
          this.selectedDate.splice(this.selectedDate.indexOf(date), 1)
          return
        }
        this.selectedDate.push(date)
      },
      checkCampaignType () { // 상품별 페이지 -> 일반상품, 인터플레이 구분
        return checkCampaignType(
          this.isInterPlay,
          this.currentCampaign.campaign_nm,
          this.contractData.contract
        )
      }
    },
    computed: {
      ...mapState({
        cgData: state => state.campaign.cgData,
        contractData: state => state.campaign.contractData,
        currentCampaign: state => state.campaign.currentCampaign
      }),
      isInterPlay () {
        return isInterPlay()
      },
      campaignType () {
        return this.checkCampaignType()
      },
      viewData () {
        return {
          data: this.cgData.creativeGroup,
          daysData: this.cgData.creativeGroupAndDate
        }
      }
    },
    created () {
      this.setCampaignDetailTap('creativeGroup')
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// CgMain.vue?30944b28